module.exports = __webpack_public_path__ + "img/MELA_DC.17a28371.png";